import type { ReactNode } from 'react';
import ScreenTopBar from '@coeldery/screen-top-bar';
import LanguageSwitcher from './LanguageSwitcher';
import { brand } from '../brand';

/**
 * HKSCA — 頁面外殼（每頁共用）
 * 用 vendor 模組 `@coeldery/screen-top-bar`（頂欄：左／中／右 slot）＋ 右邊放語言切換。
 * ⚠️ `safeAreaTop` ＝ true（本欄就係最頂 → 由佢負責 safe-area，避免雙重內距）。
 */
export default function AppShell({
  title,
  left,
  children,
}: {
  title?: string;
  left?: ReactNode;
  children: ReactNode;
}) {
  /** 預設左邊放品牌標誌（純標誌 PNG；品牌色由 tokens.css 控）；檔名由 `brand.json` 出 */
  const brandLogo = left ?? <img src={brand.logos.mark} alt="" style={{ height: 28, display: 'block' }} />;
  return (
    <div className="min-h-screen flex flex-col">
      <ScreenTopBar safeAreaTop title={title} left={brandLogo} right={<LanguageSwitcher />} />
      <main className="flex-1">{children}</main>
    </div>
  );
}
